"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureFlagEnum = void 0;
var FeatureFlagEnum;
(function (FeatureFlagEnum) {
    FeatureFlagEnum["PAID_VERSION"] = "paidVersion";
    FeatureFlagEnum["STRIPE_ENABLED"] = "stripeEnabled";
    FeatureFlagEnum["OUTGOING_WIRE_TRANSFER_ENABLED"] = "outgoingWireTransferEnabled";
    // tier 2 feature flags
    FeatureFlagEnum["COST_CENTER_GROUPS_ENABLED"] = "costCenterGroupsEnabled";
    FeatureFlagEnum["CUSTOM_CSV_TEMPLATES_ENABLED"] = "customCsvTemplatesEnabled";
    FeatureFlagEnum["SUB_COMPANIES_ENABLED"] = "subCompaniesEnabled";
    FeatureFlagEnum["TRAVEL_ENABLED"] = "travelEnabled";
    FeatureFlagEnum["CUSTOM_ROLE_ENABLED"] = "customRolesEnabled";
    FeatureFlagEnum["PURCHASE_ORDER_ENABLED"] = "purchaseOrderEnabled";
})(FeatureFlagEnum || (exports.FeatureFlagEnum = FeatureFlagEnum = {}));
